export const TokenPresets = {
  ETH: {
    icon: '692ed6ba-e569-459a-556a-776476829e00'
  },
  WETH: {
    icon: '692ed6ba-e569-459a-556a-776476829e00'
  },
  AVAX: {
    icon: '30c46e53-e989-45fb-4549-be3bd4eb3b00'
  },
  FTM: {
    icon: '06b26297-fe0c-4733-5d6b-ffa5498aac00'
  },
  BNB: {
    icon: '93564157-2e8e-4ce7-81df-b264dbee9b00'
  },
  MATIC: {
    icon: '41d04d42-da3b-4453-8506-668cc0727900'
  },
  OP: {
    icon: 'ab9c186a-c52f-464b-2906-ca59d760a400'
  }
} as Record<string, { icon: string } | undefined>
